// extracted by mini-css-extract-plugin
export var messageSideLeft = "_gv-1";
export var messageSideRight = "_gv-2";
export var orderLookupBubbleContainer = "_gv-0";
export var submitButton = "_gv-3";